module.exports = "./img/33b273ce65b28e67eceb7131ea1e782d.jpg";